<section
    [id]="id()"
    class="relative w-full h-full px-2"
    [attr.data-testid]="currentTestId()"
    [attr.data-styletarget]="id()"
>
    <section
        [attr.data-testid]="id() + '-graph'"
        [attr.data-styletarget]="id() + '-graph'"
        [attr.data-uitype]="'graph'"
        class="w-full h-full"
        #graph
    ></section>
    <section
        [attr.data-uitype]="'graph-legend'"
        class="pl-[80px] sm:pl-[25px] tablet:pl-[25px] text-dat-grey-200"
    >
        <h3 class="font-headline-5-strong sm:text-base my-0">{{ currentYear }}</h3>
        <h3 class="font-headline-5-strong sm:text-base my-0">Load-to-Truck Ratio</h3>
        <div class="flex flex-col mt-4">
            @for(range of ranges; track range.color.toCSSHex()){
            <div class="my-1">
                <span
                    [style.background-color]="range.color.toCSSHex()"
                    class="h-6 w-6 inline-block mr-4 sm:h-4 sm:w-4"
                ></span>
                @if(range.isMax) {

                <label class="mr-4 font-headline-6-strong sm:text-base">{{ range.min }}+</label>
                } @else {
                <label class="mr-4 font-headline-6-strong sm:text-base"
                    >{{ range.min }} - {{ range.max }}</label
                >
                }
            </div>
            }
        </div>
    </section>
</section>
<div [attr.data-json-info]="'lt-reefer'" class="hidden">
    {{ data() | json }}
</div>
<meta name="description" [content]="data() | json" />